import Vue from 'vue'
import {
    Toast,
    Dialog
} from 'vant'
import code from './errorCode'
// import appInfo from '../store/modules/appInfo'
import store from '../store/index'
// import ua from 'utils/ua'
// import ua1
Vue.use(Toast)
Vue.use(Dialog)

const errorHandlers = {
    // 106表示用户未登陆或者过期token
    async '106' () {
        Toast({
            message: code['106'],
            position: 'bottom'
        })
        // 清除掉当前本地token,因为这个token已经是过期的了，需要让用户重新登陆获取
        store.dispatch('loginOut').then(res => {
            // 再去登陆流程验证，此流程如果没有token就会进入登陆流程
            store.dispatch('verifyUserInfo')
        })
    },
    async '128' () {
        Toast({
            message: code['128'],
            position: 'bottom'
        })
        // 清除掉当前本地code,因为这个code已经是过期的了，需要让用户重新跳到授权页面换取新的CODE
        store.dispatch('wxCodeErr').then(res => {
            store.dispatch('getNewCode')
        })
    },
    '0' () {
        Toast({
            message: code['0'],
            position: 'bottom'
        })
    },
    '99' (errCode, errMsg) {
        Toast({
            message: errMsg,
            position: 'bottom'
        })
    },
    '111' (errCode, errMsg) {
        // Toast({
        //     message: errMsg,
        //     position: 'bottom'
        // })
    },
    '7001' () {
        Vue.$router.push({
            path: '/pageNotFound'
        })
    },
    '9001' () {
        Dialog.alert({
            message: code['9002'],
        }).then(() => {
            Vue.$router.push({
                path: '/pageNotFound'
            })
        })
    },
    '9002' () {
        Dialog.alert({
            message: code['9002'],
        }).then(() => {
            Vue.$router.push({
                path: '/pageNotFound'
            })
        })
    },
    '9003' () {
        Dialog.alert({
            message: code['9002'],
        }).then(() => {
            Vue.$router.push({
                path: '/pageNotFound'
            })
        })
    },
    default (code, msg) {
        Toast({
            message: msg,
            position: 'bottom',
            duration: 1500,
            forbidClick: true,
            closeOnClick: true
        })
    },
    abort (msg) {
        Toast({
            message: msg,
            position: 'bottom',
            duration: 1500,
            forbidClick: true,
            closeOnClick: true
        })
    },
}
export default errorHandlers
